export default __webpack_public_path__ + "static/media/logo_marvel.56cb1f40.svg";